module.exports = __webpack_public_path__ + "static/img/0547_5.9410dbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0547_5.jpg
// module id = pPLH
// module chunks = 1